import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import store from '../store'

Vue.use(Router)

const staticRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/container/Login'], resolve)
  },
  {
    path: '',
    name: 'Hello',
    component: HelloWorld
  }
]

const asyncRoutes = [
  {
    path: '/',
    name: 'Root',
    component: HelloWorld,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: resolve => require(['@/container/Home'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: 'wishMg',
        name: 'WishMg',
        component: resolve => require(['@/container/WishMg'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      }, {
        path: 'readingMg',
        name: 'readingMg',
        component: resolve => require(['@/container/ReadingMg'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      }, {
        path: '/wishConfig',
        name: 'WishConfigMg',
        component: resolve => require(['@/container/WishConfigMg'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      }, {
        path: '/newWish',
        name: 'NewWish',
        component: resolve => require(['@/container/NewWish'], resolve),
        meta: {
          roles: ['esg.admin']
        }
      }, {
        path: '/wishedit/:id',
        name: 'WishEdit',
        component: resolve => require(['@/container/NewWish'], resolve),
        meta: {
          roles: ['esg.admin']
        }
      }, {
        path: '/realnameMg',
        name: 'RealNameMg',
        component: resolve => require(['@/container/RealNameMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/realname/:id',
        name: 'realnamePage',
        component: resolve => require(['@/container/RealNamePage'], resolve),
        meta: {
          roles: []
        }
      }, {
        path: '/changeRoleMg',
        name: 'ChangeRoleMg',
        component: resolve => require(['@/container/ChangeRoleMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/changerole/:id',
        name: 'ChangeRolePage',
        component: resolve => require(['@/container/ChangeRolePage'], resolve),
        meta: {
          roles: []
        }
      }, {
        path: '/bannerMg',
        name: 'BannerMg',
        component: resolve => require(['@/container/BannerMg'], resolve),
        meta: {
          roles: ['visitor', 'editor', 'esg.admin']
        }
      }, {
        path: '/stories',
        name: 'StoryMg',
        component: resolve => require(['@/container/StoryMg'], resolve),
        meta: {
          roles: ['visitor', 'editor', 'esg.admin']
        }
      }, {
        path: '/story/:id',
        component: resolve => require(['@/container/StoryContainer'], resolve),
        meta: {
          roles: ['visitor', 'editor', 'esg.admin']
        },
        children: [
          {
            path: 'details',
            name: 'StoryPage',
            component: resolve => require(['@/container/StoryPage'], resolve),
            meta: {
              roles: ['visitor', 'editor', 'esg.admin']
            }
          }, {
            path: 'comments',
            name: 'StoryPageComments',
            component: resolve => require(['@/container/StoryPageComments'], resolve),
            meta: {
              roles: ['visitor', 'editor', 'esg.admin']
            }
          }
        ]
      }, {
        path: '/newStory',
        name: 'NewStory',
        component: resolve => require(['@/container/StoryPage'], resolve),
        meta: {
          roles: ['editor', 'esg.admin']
        }
      }, {
        path: '/users',
        name: 'users',
        component: resolve => require(['@/container/UserMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/users/:id',
        name: 'user',
        component: resolve => require(['@/container/UserPage'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/userLogins',
        name: 'userLogins',
        component: resolve => require(['@/container/UserLoginMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/userbonus',
        name: 'userbonus',
        component: resolve => require(['@/container/UserBonus'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/multipleAccounts',
        name: 'multipleAccounts',
        component: resolve => require(['@/container/MultipleAccounts'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/needsListMg',
        name: 'NeedsListMg',
        component: resolve => require(['@/container/NeedsListMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/reportedNeeds',
        name: 'ReportedNeedMg',
        component: resolve => require(['@/container/ReportedNeedsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/needItem/:id',
        name: 'NeedItemPage',
        component: resolve => require(['@/container/NeedItemPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/needsRecords',
        name: 'NeedsRecord',
        component: resolve => require(['@/container/NeedsRecordMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/needsSections',
        name: 'NeedsSectionsMg',
        component: resolve => require(['@/container/NeedsSectionsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/needRecord/:id',
        name: 'NeedRecord',
        component: resolve => require(['@/container/NeedRecordPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/gifts',
        name: 'GiftMg',
        component: resolve => require(['@/container/GiftsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/reportedGifts',
        name: 'ReportedGiftMg',
        component: resolve => require(['@/container/ReportedGiftsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/gift/:id',
        name: 'GiftPage',
        component: resolve => require(['@/container/GiftPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/giftRecords',
        name: 'GiftRecordMg',
        component: resolve => require(['@/container/GiftRecordMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/giftRecord/:id',
        name: 'GiftRecordPage',
        component: resolve => require(['@/container/GiftRecordPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/changeLogMg',
        name: 'ChangeLogMg',
        component: resolve => require(['@/container/ChangeLogMg'], resolve),
        meta: {
          roles: ['']
        }
      }, {
        path: '/feedBackMg',
        name: 'FeedBackMg',
        component: resolve => require(['@/container/FeedBackMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/feedback/:id',
        name: 'FeedBackPage',
        component: resolve => require(['@/container/FeedBackPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      }, {
        path: '/edmMg',
        name: 'EDMMg',
        component: resolve => require(['@/container/EDMListMg'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      }, {
        path: '/edm/new',
        name: 'EDMNew',
        component: resolve => require(['@/container/EDMPage'], resolve),
        meta: {
          roles: ['editor']
        }
      }, {
        path: '/edm/:id',
        name: 'EDMDetail',
        component: resolve => require(['@/container/EDMPage'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/notifyMg',
        name: 'NotifyMg',
        component: resolve => require(['@/container/NotifyListMg'], resolve),
        meta: {
          roles: ['visitor', 'editor', 'love.admin']
        }
      },
      {
        path: '/lovebox/courseNotifyMg',
        name: 'LoveboxCourseNotifyMg',
        component: resolve => require(['@/container/LoveboxCourseNotifyListMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/lovebox/companies-apply',
        name: 'LoveBoxApplyCompanies',
        component: resolve => require(['@/container/LoveboxCompanyApplyMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/lovebox/companies',
        name: 'LoveBoxCompanies',
        component: resolve => require(['@/container/LoveboxCompanyMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/lovebox/objects',
        name: 'LoveBoxObjects',
        component: resolve => require(['@/container/LoveboxObjectMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/lovebox/objects/:id',
        name: 'LoveBoxObjectsDetail',
        component: resolve => require(['@/container/LoveboxObjectPage'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/lovebox/trades',
        name: 'LoveBoxTrades',
        component: resolve => require(['@/container/LoveboxTradeMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/lovebox/trades/:id',
        name: 'LoveBoxTradeDetail',
        component: resolve => require(['@/container/LoveboxTradePage'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, {
        path: '/lovebox/application',
        name: 'LoveBoxApplication',
        component: resolve => require(['@/container/LoveboxApplication'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      }, { // GC代贈寄送記錄路由
        path: '/lovebox/dispatching',
        name: 'LoveBoxDispatching',
        component: resolve => require(['@/container/LoveboxDispatching'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/lovebox/whitelist',
        name: 'LoveBoxWhiteList',
        component: resolve => require(['@/container/love/LoveboxWhiteList'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/employees/:id',
        name: 'employees',
        component: resolve => require(['@/container/employeeMg'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/preEvents',
        name: 'preEvents',
        component: resolve => require(['@/container/PreEventMg'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/preEvent/:id',
        name: 'preEvent',
        component: resolve => require(['@/container/PreEventPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/exportpalmboxcsv',
        name: 'exportPalmBoxCSV',
        component: resolve => require(['@/container/ExportPalmBoxCSV'], resolve),
        meta: {
          roles: []
        }
      },
      {
        path: '/newconnect',
        name: 'newConnect',
        component: resolve => require(['@/container/NewConnect'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/cabinetGiftMg',
        name: 'cabinetGiftMg',
        component: resolve => require(['@/container/CabinetGiftMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/cabinetGift/:id',
        name: 'cabinetGiftPage',
        component: resolve => require(['@/container/CabinetGiftPage'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/reportedMoments',
        name: 'ReportedMomentsMg',
        component: resolve => require(['@/container/ReportedMomentsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/applyCancelDeals',
        name: 'ApplyCancelDealsMg',
        component: resolve => require(['@/container/ApplyCancelDealsMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/momentsListMg',
        name: 'MomentsListMg',
        component: resolve => require(['@/container/MomentsListMg'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/agreementConfig',
        name: 'AgreementConfig',
        component: resolve => require(['@/container/AgreementConfig'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/carbonAccountAgreementConfig',
        name: 'AgreementConfig',
        component: resolve => require(['@/container/CarbonAccountAgreementConfig'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/privacyConfig',
        name: 'PrivacyConfig',
        component: resolve => require(['@/container/PrivacyConfig'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/about543Config',
        name: 'About543Config',
        component: resolve => require(['@/container/About543Config'], resolve),
        meta: {
          roles: ['visitor', 'editor']
        }
      },
      {
        path: '/regardItem/list',
        name: 'RegardItemList',
        component: resolve => require(['@/container/regard/RegardItemList'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/regardItem/sponsors',
        name: 'RegardItemSponsors',
        component: resolve => require(['@/container/regard/RegardItemSponsors'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/regardItem/greetings',
        name: 'RegardItemGreetings',
        component: resolve => require(['@/container/regard/RegardItemGreetings'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/paymentOrders',
        name: 'PaymentOrders',
        component: resolve => require(['@/container/wallet/paymentOrders'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/paymentStatistics',
        name: 'PaymentStatistics',
        component: resolve => require(['@/container/wallet/paymentStatistics'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/walletRecords',
        name: 'WalletRecords',
        component: resolve => require(['@/container/wallet/walletRecords'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/walletRecordsStatistics',
        name: 'WalletRecordsStatistics',
        component: resolve => require(['@/container/wallet/walletRecordsStatistics'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/walletUserStatistics',
        name: 'WalletUserStatistics',
        component: resolve => require(['@/container/wallet/walletUserStatistics'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/iboxOrders',
        name: 'IBoxStatistics',
        component: resolve => require(['@/container/wallet/iboxOrders'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/hilifeOrders',
        name: 'IBoxStatistics',
        component: resolve => require(['@/container/wallet/hilifeOrders'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/sevenElevenOrders',
        name: 'SevenElevenOrders',
        component: resolve => require(['@/container/wallet/sevenElevenOrders'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/hctOrders',
        name: 'HCTOrders',
        component: resolve => require(['@/container/wallet/hctOrders'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/refunds',
        name: 'WalletRefunds',
        component: resolve => require(['@/container/wallet/refunds'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/userMarks',
        name: 'UserMarksMg',
        component: resolve => require(['@/container/UserMarksMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/organizers',
        name: 'OrganizersMg',
        component: resolve => require(['@/container/OrganizersMg'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/organizers/users',
        name: 'OrganizerUsersMg',
        component: resolve => require(['@/container/OrgainzerUsersMg'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/expresses',
        name: 'Expresses',
        component: resolve => require(['@/container/ExpressesMg'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/coupons',
        name: 'WalletCoupons',
        component: resolve => require(['@/container/wallet/coupons'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/wallet/couponRecords',
        name: 'WalletCouponRecords',
        component: resolve => require(['@/container/wallet/couponRecords'], resolve),
        meta: {
          roles: ['visitor']
        }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: resolve => require(['@/container/Settings'], resolve)
      },
      {
        path: '/carbonlabelling/organizers',
        component: resolve => require(['@/container/CarbonLabellingOrganizers'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/groups',
        component: resolve => require(['@/container/CarbonLabellingGroups'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/users',
        component: resolve => require(['@/container/CarbonLabellingUsers'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/courses',
        name: 'admin.courses',
        component: resolve => require(['@/container/course/Courses'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/courses/new',
        name: 'admin.courses.create',
        component: resolve => require(['@/container/course/CourseEdit'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/courses/:id',
        name: 'admin.courses.edit',
        component: resolve => require(['@/container/course/CourseEdit'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/subscriptions',
        name: 'admin.subscriptions',
        component: resolve => require(['@/container/course/Subscriptions'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/course-results',
        name: 'admin.courseResults',
        component: resolve => require(['@/container/course/CourseResults'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbonlabelling/report/:id',
        name: 'CarbonLabellingReport',
        component: resolve => require(['@/container/CarbonLabellingReport'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/welfare/enterprises',
        component: resolve => require(['@/container/WelfareEnterprises'], resolve)
      },
      {
        path: '/giftRatings',
        component: resolve => require(['@/container/GiftRatings'], resolve)
      },
      {
        path: '/lovebox/company-report/:id',
        name: 'LoveboxCompanyReport',
        component: resolve => require(['@/container/LoveboxCompanyReport'], resolve),
        meta: {
          roles: ['visitor', 'love.admin', 'esg.admin']
        }
      },
      {
        path: '/companyPages',
        component: resolve => require(['@/container/CompanyPages'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbon-account/products',
        name: 'CarbonAccountProducts',
        component: resolve => require(['@/container/carbon_account/Products'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbon-account/orders',
        name: 'CarbonAccountOrders',
        component: resolve => require(['@/container/carbon_account/Orders'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbon-account/discounts',
        name: 'CarbonAccountDiscounts',
        component: resolve => require(['@/container/carbon_account/DiscountCodes'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbon-account/discount-records',
        name: 'CarbonAccountDiscountRecords',
        component: resolve => require(['@/container/carbon_account/DiscountCodeRecords'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/carbon-account/contacts',
        name: 'CarbonAccountContacts',
        component: resolve => require(['@/container/carbon_account/Contacts'], resolve),
        meta: {
          roles: ['visitor', 'esg.admin']
        }
      },
      {
        path: '/',
        name: ''
      }
    ]
  },
  {
    path: '/carbonLabelling/:id/thanks',
    name: 'CarbonLabellingThanks',
    component: resolve => require(['@/container/CarbonLabellingThanks'], resolve),
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  },
  {
    path: '/lovebox/company-report/:id/thanks',
    name: 'LoveboxCompanyThanks',
    component: resolve => require(['@/container/LoveboxCompanyThanks'], resolve),
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  },
  {
    path: '*',
    name: '_404Page',
    component: resolve => require(['@/container/_404Page'], resolve)
  }
]

const router = new Router({
  mode: 'history',
  routes: staticRoutes
})

const hasPermission = (roles, route) => {
  if (route && route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}

const matchRoutes = (roles) => {
  const accessRoutes = asyncRoutes.filter(route => {
    if (roles.includes('admin')) {
      return true
    }

    if (hasPermission(roles, route)) {
      if (route.children && route.children.length > 0) {
        route.children = route.children.filter(child => {
          if (roles.includes('admin')) {
            return true
          }

          if (hasPermission(roles, child)) {
            return true
          }

          return false
        })
      }

      return true
    }

    return false
  })

  return accessRoutes
}

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  let token = localStorage.getItem('token')
  if (token) {
    if (store.getters.roles.length === 0) {
      store.dispatch('getUserInfo')
        .then(res => {
          const roles = res.data.roles
          router.addRoutes(matchRoutes(roles))
          if (to.path === '/') {
            if (roles.some(role => ['admin', 'visitor', 'esg.admin'].indexOf(role) >= 0)) {
              next({ path: '/home', replace: true })
            } else if (roles.includes('editor')) {
              next({ path: '/stories', replace: true })
            } else if (roles.includes('love.admin')) {
              next({ path: '/lovebox/trades', replace: true })
            } else {
              next({ ...to, replace: true })
            }
          } else {
            next({ ...to, replace: true })
          }
        })
        .catch(err => {
          console.log(err)
          next({ path: '/login' })
        })
    } else {
      next()
    }
  } else if (to.path === '/login') {
    next()
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js